import classNames from "classnames";

import styles from "./Stepper.module.scss";

interface Step {
  label: string;
  value: string;
  available?: boolean;
}

interface StepperProps {
  steps: Step[];
  currentStep: string;
  onStepChange?: (stepValue: string) => void;
  cumulativeActive?: boolean;
}

export const Stepper: React.FC<StepperProps> = ({ steps, currentStep, onStepChange, cumulativeActive = false }) => {
  const handleStepClick = (stepValue: string) => {
    if (stepValue === currentStep) return;
    if (steps.find((step) => step.value === stepValue && step.available === false)) return;
    onStepChange?.(stepValue);
  };

  const currentStepIndex = steps.findIndex((step) => step.value === currentStep);

  return (
    <div className={styles.stepper} style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}>
      {steps.map((step, i) => {
        const isActive = cumulativeActive ? i <= currentStepIndex : step.value === currentStep;
        return (
          <div
            key={step.value}
            className={classNames(styles.step, {
              [styles.active]: isActive,
              [styles.available]: step.available,
            })}
            onClick={() => handleStepClick(step.value)}
          >
            <h4 className={styles.stepNumber}>{i + 1}</h4>
            <p className={styles.stepLabel}>{step.label}</p>
          </div>
        );
      })}
    </div>
  );
};
